import type { HelpPortalSource } from "@/lib/help-portal";
import {
  OMT_AMS_HELP_ARTICLES,
  OMT_AMS_HELP_CATEGORIES,
  omtAmsArticlesInCategory,
} from "@/lib/omt-ams-help/articles";
import { searchOmtAmsHelpArticles } from "@/lib/omt-ams-help/search";

export {
  OMT_AMS_HELP_ARTICLES,
  OMT_AMS_HELP_ARTICLE_IDS,
  OMT_AMS_HELP_CATEGORIES,
  getOmtAmsHelpArticle,
  isOmtAmsHelpArticleId,
  omtAmsArticlesInCategory,
} from "@/lib/omt-ams-help/articles";
export { getOmtAmsDashboardContextHelpArticleId } from "@/lib/omt-ams-help/context";
export { searchOmtAmsHelpArticles } from "@/lib/omt-ams-help/search";
export type { OmtAmsHelpArticleId } from "@/lib/omt-ams-help/articles";

export const OMT_AMS_HELP_PORTAL: HelpPortalSource = {
  articles: OMT_AMS_HELP_ARTICLES,
  categories: OMT_AMS_HELP_CATEGORIES,
  searchArticles: searchOmtAmsHelpArticles,
  articlesInCategory: omtAmsArticlesInCategory,
  indexTo: "/omt-ams/help",
  articleTo: "/omt-ams/help/$articleId",
  emptySearchHint:
    "Try a different word, such as dashboard, registration, invite, users, or account.",
};
